export default __webpack_public_path__ + "static/insurance-welcome-back-4f59695d6eb6bb6c569d5572e7e630fa.webp";